/* eslint-disable import/no-duplicates */
/* eslint-disable no-lonely-if */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-useless-escape */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useLayoutEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { produce } from 'immer';
// context
import StepperContext from '../../components/molecules/Stepper/StepperContext';
import LoaderContext from '../../components/molecules/Loader/LoaderContext';
// configs
import routes from '../../../application/config/routes';
// models
import personalDataUiModel from './uiModel';
// components
import PersonalDataTemplate from '../../components/templates/PersonalDataTemplate/PersonalDataTemplate';
// actions
import { personalDataActions } from '../../../application/actions/personalData';
import { executiveActions } from '../../../application/actions/executive';
import { identityActions } from '../../../application/actions/identity';
// utils
import { isArray } from '../../../domain/utils/utilitarios-frontend-coopeuch/array';
import { insertStringAfterBeforeCharOrString } from '../../../domain/utils/utilitarios-frontend-coopeuch/text';

import { isMobile } from '../../utils/platform';
import { saveAllEntitiesToStorage, saveAllEntitiesFromStorage } from '../../utils/storage';
import { formatRut, RutFormat } from '../../../domain/utils/utilitarios-frontend-coopeuch/rut';
import { getAlphanumericRandomString } from '../../../domain/utils/utilitarios-frontend-coopeuch/text';
import sendAnalitycs from '../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../domain/utils/dataLayerObject';
import { genPayloadToRegisterPersonalData } from './payload';

import { useModal } from '../../hooks/useModal';
import edgeCases from '../../localData/edgeCases';

// constants
/* istanbul ignore next */
const safesignerState = getAlphanumericRandomString(12);
const safesignerNonce = getAlphanumericRandomString(12);
const isDeviceMobile = isMobile();

/* istanbul ignore next */
const PersonalDataContainer = () => {
  const [rut, setRut] = useState({ ...personalDataUiModel.rut });
  const [serialNumber, setSerialNumber] = useState({ ...personalDataUiModel.serialNumber });
  const [firstName, setFirstName] = useState({ ...personalDataUiModel.firstName });
  const [lastName, setLastName] = useState({ ...personalDataUiModel.lastName });
  const [maternalLastName, setMaternalLastName] = useState({
    ...personalDataUiModel.maternalLastName,
  });
  /* istanbul ignore next */
  const [profession, setProfession] = useState({ ...personalDataUiModel.profession });
  const [position, setPosition] = useState({ ...personalDataUiModel.position });
  const [workActivity, setWorkActivity] = useState({ ...personalDataUiModel.workActivity });
  const [countryNationality, setCountryNationlity] = useState({
    ...personalDataUiModel.countryNationality,
  });
  /* istanbul ignore next */
  const [phone, setPhone] = useState({ ...personalDataUiModel.phone });
  const [confirmationPhone, setConfirmationPhone] = useState({
    ...personalDataUiModel.confirmationPhone,
  });
  /* istanbul ignore next */
  const [email, setEmail] = useState({ ...personalDataUiModel.email });
  const [address, setAddress] = useState({ ...personalDataUiModel.address });
  const [taxDeclaration, setTaxDeclaration] = useState({ ...personalDataUiModel.taxDeclaration });
  const [preferredOffice, setPreferredOffice] = useState({
    ...personalDataUiModel.preferredOffice,
  });
  /* istanbul ignore next */
  const [isValidPerson, setIsValidPerson] = useState(false);
  const [previredAuthorization, setPreviredAuthorization] = useState({
    ...personalDataUiModel.previredAuthorization,
  });
  /* istanbul ignore next */
  const [isValidStep, setIsValidStep] = useState(false);
  const [isCompletedCardPersonValidation, setIsCompletedCardPersonValidation] = useState(false);
  const [isCompletedCardPersonalData, setIsCompletedCardPersonalData] = useState(false);
  const [isCompletedCardContacData, setIsCompletedCardContactData] = useState(false);
  const [isCompletedCardPreferredOffice, setIsCompletedCardPreferredOffice] = useState(false);
  const [isCompletedCardDeclarationsData, setIsCompletedCardDeclarationsData] = useState(false);
  const [isVisiblePreferredOffice, setIsVisiblePreferredOffice] = useState(false);

  // const [isSavedPersonalDa, setIsSavedPersonalData] = useState(false);
  /* istanbul ignore next */
  const [showIsRequiredPreviredAuthorization, setShowIsRequiredPreviredAuthorization] =
    useState(false);
  const [currentEdgeCase, setCurrentEdgeCase] = useState({
    title: '',
  });
  /* istanbul ignore next */
  const [officesItems, setOfficesIofficesItems] = useState([]);
  const [executiveCode, setExecutiveCode] = useState({ ...personalDataUiModel.executiveCode });
  const [executiveAttending, setExecutiveAttending] = useState({
    ...personalDataUiModel.executiveAttending,
  });
  /* istanbul ignore next */
  const [isValidExecutiveCode, setIsValidExecutiveCode] = useState('optional'); // values: 'optional' / 'valid' / 'invalid'
  /* istanbul ignore next */
  const appRoutes = routes();
  const history = useHistory();
  const dispatch = useDispatch();
  // TODO: mover la logica de conexion a parametros a un Custom Hook
  // const ufParams = useSelector((store) => store.entities.uf);
  /* istanbul ignore next */
  const professionItems = useSelector((store) => store.entities.profession.professions);
  const positionItems = useSelector((store) => store.entities.position.position);
  const workActivityItems = useSelector((store) => store.entities.workActivity.workActivity);
  const countryNationalityItems = useSelector(
    (store) => store.entities.countryNationality.countryNationality
  );
  /* istanbul ignore next */
  const indicators = useSelector((store) => store.entities.indicators);
  const regionsWithOfficesItems = useSelector((store) => store.entities.offices.offices);
  /* istanbul ignore next */
  const validatePersonalData = useSelector(
    (store) => store.entities.personalData.validatePersonalData
  );
  /* istanbul ignore next */
  const isLoadingFetchExecutive = useSelector((store) => store.ui.loaders.isLoadingFetchExecutive);
  const executive = useSelector((store) => store.entities.executive);
  const isLoadingValidatePersonalData = useSelector(
    (store) => store.ui.loaders.isLoadingValidatePersonalData
  );
  /* istanbul ignore next */
  const registerPersonalData = useSelector(
    (store) => store.entities.personalData.registerPersonalData
  );
  /* istanbul ignore next */
  const isLoadingRegisterPersonalData = useSelector(
    (store) => store.ui.loaders.isLoadingRegisterPersonalData
  );
  /* istanbul ignore next */
  const validateIdentity = useSelector((store) => store.entities.identity.validateIdentity);
  const isLoadingValidateIdentity = useSelector(
    (store) => store.ui.loaders.isLoadingValidateIdentity
  );
  /* istanbul ignore next */
  const [isOpenModalEdgeCase, openModalEdgeCase, closeModalEdgeCase] = useModal(false);
  const [
    isOpenModalAlreadyMemberRedirection,
    setIsOpenModalAlreadyMemberRedirection,
    // closeModalAlreadyMemberRedirection,
  ] = useModal(false);
  const [isOpenModalAbandonmentSurvey, setIsOpenModalAbandonmentSurvey, closeModalAbandonmentSurvey] = useModal(false)
  /* istanbul ignore next */
  const { handleChangeStep } = useContext(StepperContext);
  const { handleChangeLoading } = useContext(LoaderContext);

  // const { handleChangeLoading } = useContext(LoaderContext);
  /* istanbul ignore next */
  const tempRedirectUrl = `${window.location.origin}${window.location.pathname}`
  const redirectUrl = tempRedirectUrl.at(-1) === '/' ? tempRedirectUrl.slice(0, -1) : tempRedirectUrl;
  const expectPreviousPage = process.env.REACT_APP_SAFESIGNER_URL;
  const redirectSafesigner = `${process.env.REACT_APP_SAFESIGNER_INTEGRATION_URL}?c=${process.env.REACT_APP_SAFESIGNER_C}&client_id=${process.env.REACT_APP_SAFESIGNER_CLIENT_ID}&scope=${process.env.REACT_APP_SAFESIGNER_SCOPE}&redirect_uri=${redirectUrl}&state=${safesignerState}&nonce=${safesignerNonce}&error_redirect=true&rut=${rut.value}&e=${email.value}&identity_doc=${serialNumber.value}`;
  /* istanbul ignore next */
  const stateFields = (dataType) => {
    const fields = {
      rut,
      serialNumber,
      firstName,
      lastName,
      maternalLastName,
      profession,
      position,
      workActivity,
      countryNationality,
      phone,
      confirmationPhone,
      email,
      address,
      taxDeclaration,
      previredAuthorization,
      executiveCode,
      executiveAttending,
      preferredOffice,
    };
    return dataType === 'array' ? Object.values(fields) : { ...fields };
  };
  /* istanbul ignore next */
  const stateMap = {
    rut: { state: rut, seter: setRut },
    serialNumber: { state: serialNumber, seter: setSerialNumber },
    firstName: { state: firstName, seter: setFirstName },
    lastName: { state: lastName, seter: setLastName },
    maternalLastName: { state: maternalLastName, seter: setMaternalLastName },
    profession: { state: profession, seter: setProfession },
    position: { state: position, seter: setPosition },
    workActivity: { state: workActivity, seter: setWorkActivity },
    countryNationality: { state: countryNationality, seter: setCountryNationlity },
    phone: { state: phone, seter: setPhone },
    confirmationPhone: { state: confirmationPhone, seter: setConfirmationPhone },
    email: { state: email, seter: setEmail },
    address: { state: address, seter: setAddress },
    taxDeclaration: { state: taxDeclaration, seter: setTaxDeclaration },
    previredAuthorization: { state: previredAuthorization, seter: setPreviredAuthorization },
    executiveCode: {
      state: executiveCode,
      seter: setExecutiveCode,
    },
    executiveAttending: {
      state: executiveAttending,
      seter: setExecutiveAttending,
    },
    preferredOffice: {
      state: preferredOffice,
      seter: setPreferredOffice,
    },
  };
  /* istanbul ignore next */
  const entitiesInCard = {
    CardPersonValidation: [rut, serialNumber, previredAuthorization],
    CardPersonalData: [
      firstName,
      lastName,
      maternalLastName,
      profession,
      workActivity,
      position,
      countryNationality,
    ],
    CardContactData: [email, phone, confirmationPhone, address],
    CardPreferredOffice: [preferredOffice, executiveAttending],
    CardDeclarationsData: [taxDeclaration],
  };
  /* istanbul ignore next */
  const getCompletedCard = (cardName) => {
    return entitiesInCard[cardName]
      .filter((el) => el.isVisible)
      .map((el) => el.isValid(el.value) && el.errors.length === 0)
      .every((val) => val === true);
  };
  /* istanbul ignore next */
  useLayoutEffect(() => {
    if (sessionStorage.getItem('correctStep')) {
      if (String(sessionStorage.getItem('correctStep')) === '1') {
        // COMMENT: VIENE DE SAFESIGNER o SE REFRESCO EL NAVEGADOR ANTE UN ERROR DE VALIDACION DE IDENTIDAD
        const previousPage = window.document.referrer;
        const queryParams = new URLSearchParams(history.location.search);
        if (history.location.search !== '' && expectPreviousPage === previousPage) {
          const code = queryParams.get('code') || '';
          const error = queryParams.get('error') || '';
          const errorDescription = queryParams.get('error_description') || '';
          const state = queryParams.get('state') || '';
          const payloadIdentityValidation = { code, error, errorDescription };
          if (state === sessionStorage.getItem('safesigner-state')) {
            handleChangeLoading(true);
            // COMMENT: borramos el state guardado para no entrar en esta condicion por si actualiza la pagina
            sessionStorage.setItem('safesigner-state', '');
            dispatch(identityActions.validateIdentity(payloadIdentityValidation));
          } else {
            // TODO: PENDIENTE CASO BORDE CUANDO NO COINCIDAN LOS VALORES
            console.log("CASO BORDE NO CONTROLADO: los state no coinciden")
          }
        } else {
          console.log("CASO BORDE NO CONTROLADO: TIENE EL PASO, no hay queryparams, se borraron los parametros en la url y se regrescó, o no corresponde el previouspath - ERROR NO CONTROLADO");
        }
      } else if (String(sessionStorage.getItem('correctStep')) === '2') {
        // COMMENT: viene del paso 2 preferencias o de un retroceso seguido de pasos siguientes
        // COMMENT: VIENE DEL PASO 2 YA SEA CON REFRESCO DE PANTALLA EN ESE PASO');
        history.push(appRoutes.contracts.path, { from: '/datos-personales' });
      } else {
        // COMMENT: VIENE DEL PASO 3 donde ya creo el socio (puede que en la misma pestaña borra el path y se queda con el dominio o se va al sitio publico y quiere hacer otra vez el enrolamiento)
        sendAnalitycs(dataLayerObject.PERSONAL_DATA_LOADED);
        sessionStorage.setItem('correctStep', String(1));
      }
    } else {
      // COMMENT: PRIMERA VEZ QUE LLEGA AL FLUJO, PUEDE VENIR DE INDEX O DESDE UNA URL DEL AREA DE CANALES TIPO: .../datos-personales?x=xxx&y=yyy
      // COMMENT: "AQUI GUARDAMOS correctStep";
      sessionStorage.setItem('correctStep', String(1));
      sendAnalitycs(dataLayerObject.PERSONAL_DATA_LOADED);
      handleChangeStep(1);
    }
  }, []);
  /* istanbul ignore next */
  useEffect(() => {
    const registeredPersonalData = sessionStorage.getItem('registered-person-data') || '';
    if (currentEdgeCase.blocker === false && registeredPersonalData === 'OK') {
      // COMMENT: como seguiremos en el paso 1, ya no es necesario volver a validar el documento de identidad
      const valuesFromStorageToSave = saveAllEntitiesFromStorage(stateFields('object'), [
        'profession',
        'workActivity',
        'countryNationality',
        'position',
      ]);
      valuesFromStorageToSave.forEach((entity) => {
        const nextState = produce((draft) => {
          draft.value = entity.value;
        });
        stateMap[entity.key].seter(nextState);
      });
      const nextStateCountryNationality = produce((draft) => {
        draft.isVisible = sessionStorage.getItem('country-nationality-visivility') === 'true';
      });
      setCountryNationlity(nextStateCountryNationality);
      setIsValidPerson(true);
      // TODO: VERIFICAR SI ES NECESARIA HABILITAR EL PASO 0 PARA EL CODIGO 22, donde se le pide que ingrese con otros datos la validacion del documento de identidad.
    }
  }, [currentEdgeCase])
  /* istanbul ignore next */
  useEffect(() => {
    if (executive.successFetching) {
      if (executive.executive && executive.executive.code !== '') setIsValidExecutiveCode('valid');
    } else if (executive.errorFetching) {
      setIsValidExecutiveCode('invalid');
    }
  }, [executive]);
  /* istanbul ignore next */
  useEffect(() => {
    if (indicators.successFetching === true && indicators.indicators.length) {
      const ufObject = indicators.indicators.filter((el) => el.tipo.toUpperCase() === 'UF')[0];
      sessionStorage.setItem('uf-value', ufObject.valor);
      sessionStorage.setItem('uf-date', ufObject.fecha);
    }
  }, [indicators]);
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardPersonValidation(getCompletedCard('CardPersonValidation')),
    [entitiesInCard.CardPersonValidation]
  );
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardPersonalData(getCompletedCard('CardPersonalData')),
    [entitiesInCard.CardPersonalData]
  );
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardContactData(getCompletedCard('CardContactData')),
    [entitiesInCard.CardContactData]
  );
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardPreferredOffice(getCompletedCard('CardPreferredOffice')),
    [entitiesInCard.CardPreferredOffice]
  );
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardDeclarationsData(getCompletedCard('CardDeclarationsData')),
    [entitiesInCard.CardDeclarationsData]
  );
  /* istanbul ignore next */
  useEffect(() => {
    setIsValidStep(
      isCompletedCardPersonalData &&
      isCompletedCardPersonValidation &&
      isCompletedCardContacData &&
      isCompletedCardPreferredOffice &&
      isCompletedCardDeclarationsData
    );
  }, [
    isCompletedCardPersonalData,
    isCompletedCardPersonValidation,
    isCompletedCardContacData,
    isCompletedCardPreferredOffice,
    isCompletedCardDeclarationsData,
  ]);
  /* istanbul ignore next */
  useEffect(() => {
    if (dataLayerObject[currentEdgeCase.casesDataLayer])
      sendAnalitycs(dataLayerObject[currentEdgeCase.casesDataLayer]);
  }, [currentEdgeCase]);
  /* istanbul ignore next */
  useEffect(() => {
    if (!isOpenModalEdgeCase && currentEdgeCase.title !== '') setCurrentEdgeCase({ title: '' });
  }, [isOpenModalEdgeCase]);
  /* istanbul ignore next */
  useEffect(() => {
    if (validatePersonalData.success) {
      sendAnalitycs(dataLayerObject.PERSONAL_DATA_VERIFIED_CEDULE);
      setIsValidPerson(true);
      if (String(validatePersonalData.person.nationality).toUpperCase() === 'E') {
        const nextStateCountryNationality = produce((draft) => {
          draft.isVisible = true;
        });
        setCountryNationlity(nextStateCountryNationality);
      }
      sessionStorage.setItem('token', validatePersonalData.token);
      // COMMENT: Obtenemos firstName, lastName y maternalLastName de la entidad que se guardó cuando se ejecuto el action
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(validatePersonalData.person)) {
        if (key !== 'profession' && key !== 'nationality') {
          const nextStateItemValidatePersonalData = produce((draft) => {
            draft.value = value;
          });
          stateMap[key].seter(nextStateItemValidatePersonalData);
        }
      }
      const professionFiltered = professionItems?.filter(
        (el) => validatePersonalData.person.profession.toUpperCase() === el.valor.toUpperCase()
      )[0];
      if (professionFiltered) {
        const nextStateProfession = produce((draft) => {
          draft.value = { ...professionFiltered };
        });
        stateMap.profession.seter(nextStateProfession);
      }
    } else if (validatePersonalData.error) {
      if (validatePersonalData.code === '12') {
        // COMMENT: Socio vigente
        sessionStorage.setItem('token', validatePersonalData.message);
        setIsOpenModalAlreadyMemberRedirection(true);
      } else {
        openModalEdgeCase(); // COMMENT: se agrega otra condicion ya que no todos los casos bordes abren este modal
        if (validatePersonalData.code === '11') {
          // COMMENT: Exsocio con renuncia vigente
          setCurrentEdgeCase(edgeCases.recentFormerPartner);
        } else if (validatePersonalData.code === '8') {
          // COMMENT: Menor de Edad
          setCurrentEdgeCase(edgeCases.underage);
        } else if (validatePersonalData.code === '7') {
          // COMMENT: Persona Jurídica
          setCurrentEdgeCase(edgeCases.legalPerson);
        } else if (validatePersonalData.code === '13') {
          // COMMENT: FATCA CRS
          setCurrentEdgeCase(edgeCases.fatca);
        } else if (validatePersonalData.code === '71') {
          // COMMENT: FALLECIDOS
          setCurrentEdgeCase(edgeCases.genericExitFlow);
        } else if (validatePersonalData.code === '-1') {
          // COMMENT: HORARIO RESTRINGIDO
          setCurrentEdgeCase(edgeCases.restrictedHours);
        } else if (validatePersonalData.code === '85') {
          // COMMENT: SOCIO CON CUOTAS IMPAGAS
          setCurrentEdgeCase(edgeCases.customerWithUnpaidFees);
        } else if(validatePersonalData.code === '101'){
          dispatch(personalDataActions.changeStateBadSerial({ stateSerial: true }));
        } else if (validatePersonalData.code === '104'){
          setCurrentEdgeCase(edgeCases.limitHorario);
        } else {
          setCurrentEdgeCase(edgeCases.generic);
        }
      }
    }
  }, [validatePersonalData]);
  /* istanbul ignore next */
  useEffect(() => {
    // COMMENT: "SI NO CONTROLAMOS ESTO SIEMPRE LLAMA handleChangeLoading con " + isLoadingRegisterPersonalData
    if (isLoadingRegisterPersonalData !== null) {
      if (!isLoadingRegisterPersonalData)
        setTimeout(() => handleChangeLoading(isLoadingRegisterPersonalData), 100);
      else handleChangeLoading(isLoadingRegisterPersonalData);
    }
  }, [isLoadingRegisterPersonalData]);
  /* istanbul ignore next */
  useEffect(() => {
    if (isLoadingValidateIdentity !== null) {
      if (!isLoadingValidateIdentity)
        setTimeout(() => handleChangeLoading(isLoadingValidateIdentity), 100);
      else handleChangeLoading(isLoadingValidateIdentity);
    }
  }, [isLoadingValidateIdentity]);
  /* istanbul ignore next */
  useEffect(() => {
    if (registerPersonalData.success) {
      saveAllEntitiesToStorage(stateFields('object'));
      sessionStorage.setItem('registered-person-data', 'OK');
      sessionStorage.setItem('another-data-address', address.anotherData);
      sessionStorage.setItem('country-nationality-visivility', countryNationality.isVisible);
      sessionStorage.setItem('safesigner-state', safesignerState);
      window.location = redirectSafesigner;
    } else if (registerPersonalData.error) {
      openModalEdgeCase();
      if (registerPersonalData.code === '5') {
        // COMMENT: FATCA CRS
        setCurrentEdgeCase(edgeCases.fatca);
      } else if (registerPersonalData.code === '4' || registerPersonalData.code === '9') {
        // COMMENT: LISTA NEGRA
        setCurrentEdgeCase(edgeCases.genericExitFlow);
      } else if (registerPersonalData.code === '41') {
        // COMMENT: BLOQUEO EXTRANJEROS
        setCurrentEdgeCase(edgeCases.restrictionToForeigners);
      } else {
        setCurrentEdgeCase(edgeCases.generic);
      }
    }
  }, [registerPersonalData]);
  /* istanbul ignore next */
  useEffect(() => {
    if (validateIdentity.success) {
      handleChangeLoading(false);
      if (validateIdentity.code === 200) {
        sessionStorage.setItem('correctStep', String(2));
        history.push(appRoutes.contracts.path, { from: history.location.pathname });
      } else {
        openModalEdgeCase();
        if (validateIdentity.errorDetail.id === '3') {
          // COMMENT: INTENTOS AGOTADOS
          setCurrentEdgeCase(edgeCases.identityValidationAttemptsExceeded);
        } else if (
          validateIdentity.errorDetail.id === '5' ||
          validateIdentity.errorDetail.id === '41'
        ) {
          // COMMENT: ERROR OBTENIENDO PREGUNTAS, codigos 5 y 41 respectivamente desde safesigner
          setCurrentEdgeCase(edgeCases.identityValidationBlockingGenericError);
        } else if (validateIdentity.errorDetail.id === '1') {
          // COMMENT: Clave única no disponible
          setCurrentEdgeCase(edgeCases.identityValidationNotAvailable);
        } else if (validateIdentity.errorDetail.id === '22') {
          // COMMENT: Reingresa con tu numero de serie
          setCurrentEdgeCase(edgeCases.identityValidationWrongAccount);
        } else if (validateIdentity.errorDetail.id === '117') {
          // COMMENT: Bloqueado por numero de intentos maximo excedido
          setCurrentEdgeCase(edgeCases.identityFacialBiometryAttemptsExceeded);
        } else if (
          validateIdentity.errorDetail.id === '79' ||
          validateIdentity.errorDetail.id === '90' ||
          validateIdentity.errorDetail.id === '113' ||
          validateIdentity.errorDetail.id === '118' ||
          validateIdentity.errorDetail.id === '119'
        ) {
          // COMMENT: Errors with facial biometry
          setCurrentEdgeCase(edgeCases.identityFacialBiometryError);
        } else {
          if (validateIdentity.errorDetail.blocker) {
            // COMMENT: aquí entraran los errores bloqueantes con mensaje genérico, como por ahora el error
            setCurrentEdgeCase(edgeCases.identityValidationNotAvailable);
          } else {
            setCurrentEdgeCase(edgeCases.identityValidationRetry);
          }
        }
      }
    } else if (validateIdentity.error) {
      // COMMENT: error no mapeado, donde se puede cerrar el modal y continuar
      handleChangeLoading(false);
      openModalEdgeCase();
      const nextStateCountryNationality = produce((draft) => {
        draft.isVisible = sessionStorage.getItem('country-nationality-visivility') === 'true';
      });
      setCountryNationlity(nextStateCountryNationality);
      setIsValidPerson(true);
      setCurrentEdgeCase(edgeCases.identityValidationRetry);
    }
  }, [validateIdentity]);
  /* istanbul ignore next */
  const handleRedirectToPublicSite = () => {
    window.location = appRoutes.landing.path;
    // TODO: LIMPIAR SESSION STORAGE POR SI EL USUARIO VUELVE AL FLUJO EN LA MISMA PESTAÑA
  };
  /* istanbul ignore next */
  const handleRedirectToPrivateSite = (caseAnalityc) => {
    if (dataLayerObject[caseAnalityc])
      sendAnalitycs(dataLayerObject[caseAnalityc]);
    window.location = appRoutes.privateSite.path;
  };
 /* istanbul ignore next */
  const handleActionButtonCaseBorder = () => {
    if (currentEdgeCase.redirect === 'privateSite')
      handleRedirectToPrivateSite(`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`);
    else if (currentEdgeCase.redirect === 'publicSite') {
      if (dataLayerObject[`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`])
        sendAnalitycs(dataLayerObject[`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`]);
      handleRedirectToPublicSite();
    } else closeModalEdgeCase();
  };
  /* istanbul ignore next */
  const getFormattedValue = (field, property, value) => {
    /* istanbul ignore next */
    if (
      (field === 'firstName' || field === 'lastName' || field === 'maternalLastName') &&
      stateMap[field].state.value.trim() === ''
    ) {
      /* istanbul ignore next */
      return value.toUpperCase();
    }
    /* istanbul ignore next */
    if (field === 'address' && property === 'anotherData') {
      return value.replace(/[^a-z0-9\s]/gi, '');
    }
    /* istanbul ignore next */
    if (field === 'rut') {
      return value.replace(/[^a-z0-9\-]/gi, '');
    }
    /* istanbul ignore next */
    if (field === 'serialNumber') {
      return value.replace(/[^a-z0-9]/gi, '');
    }
    /* istanbul ignore next */
    if (field === "email") {
      return value.replace(/[^a-zA-Z0-9._+\-@]/g, '');
    }
    /* istanbul ignore next */
    return value;
  };
  /* istanbul ignore next */
  const handleChangeField = ({ field, property, value, extra }) => {
    /* istanbul ignore next */
    const generateErrorsList = () => {
      const errors = [];
      const isValidValue = isArray(stateMap[field])
        ? stateMap[field][extra.index].isValid(value)
        : stateMap[field].state.isValid(value);

      if (!isValidValue) errors.push({ text: 'El formato ingresado es incorrecto', type: 'error' });
      else if (
        stateMap[field].state.complement &&
        stateMap[stateMap[field].state.complement].state.value !== '' &&
        value !== stateMap[stateMap[field].state.complement].state.value
      )
        if (field === 'phone' || field === 'confirmationPhone')
          errors.push({ text: 'los teléfonos no coinciden', type: 'error' });
      return errors;
    };
    /* istanbul ignore next */
    const errorsList = property === 'value' ? generateErrorsList() : [];

    // COMMENT: si actividad laboral es "Dependiente" mostramos el select Cargo
    /* istanbul ignore next */
    if (field === 'workActivity') {
      const nextState = produce((draft) => {
        draft.isVisible = value.id === '01';
      });
      setPosition(nextState);
    }
    /* istanbul ignore next */
    const finalValue = getFormattedValue(field, property, value);
    /* istanbul ignore next */
    if (field === 'executiveAttending' && value === 'NO') {
      if (executiveCode.value !== '') {
        const nextExecutiveCode = produce((draft) => {
          draft.value = '';
        });
        stateMap.executiveCode.seter(nextExecutiveCode);
      }
    }
    /* istanbul ignore next */
    const nextState = produce((draft) => {
      if (isArray(stateMap[field].state)) {
        draft[extra.index][property] = finalValue;
        draft[extra.index].errors = errorsList;
      } else {
        draft[property] = finalValue;
        draft.errors = errorsList;
      }
    });
    /* istanbul ignore next */
    stateMap[field].seter(nextState);

    // COMMENT: si existe un field complemento al cual se le agreggo un mensaje de error, lo sacamos
    /* istanbul ignore next */
    if (
      stateMap[field].state.complement &&
      stateMap[stateMap[field].state.complement].state.errors.length > 0
    ) {
      const nextStateField = produce((draft) => {
        draft.errors = errorsList;
      });
      stateMap[stateMap[field].state.complement].seter(nextStateField);
    }
  };
  
  /* istanbul ignore next */
  const handleValidatePerson = () => {
    sendAnalitycs(dataLayerObject.PERSONAL_DATA_CEDULE_VERIFICATION);
    if (isCompletedCardPersonValidation) {
      const payloadValidatePerson = {
        rut: formatRut(rut.value, RutFormat.DASH),
        numeroSerie: serialNumber.value,
      };
      dispatch(personalDataActions.validatePersonalData(payloadValidatePerson));
    } else if (!previredAuthorization.value) {
      setShowIsRequiredPreviredAuthorization(true);
    }
  };
  /* istanbul ignore next */
  const handleChangeRegion = async (regionSelected) => {
    setIsVisiblePreferredOffice(false);
    // COMMENT: llenamos officeList
    const nextPreferredOffice = produce((draft) => {
      draft.value = {
        ...personalDataUiModel.preferredOffice.value,
      };
    });
    stateMap.preferredOffice.seter(nextPreferredOffice);
    setOfficesIofficesItems(
      regionSelected.comunas
        .reduce(
          (prev, curr) => [
            ...prev,
            ...curr.sucursales.map((office) => {
              return {
                value: office.codigoOficina,
                label: office.sucursal,
                address: office.direccion,
                commune: curr.nombre,
                officeHours: office.horario,
                region: regionSelected.region,
              };
            }),
          ],
          []
        )
        .filter((el) => el)
    );
  };
  /* istanbul ignore next */
  const handleChangeOffice = (officeSelected) => {
    setIsVisiblePreferredOffice(true);
    // COMMENT: llenamos lo datos de la oficina seleccionada
    const nextPreferredOffice = produce((draft) => {
      draft.value = {
        ...preferredOffice.value,
        id: officeSelected.value,
        name: officeSelected.label,
        commune: officeSelected.commune,
        region: officeSelected.region,
        address: officeSelected.address,
        officeHours: insertStringAfterBeforeCharOrString(
          officeSelected.officeHours,
          '<br />',
          'viernes',
          false
        ),
      };
    });
    stateMap.preferredOffice.seter(nextPreferredOffice);
  };
  /* istanbul ignore next */
  const handleChangeExecutiveCode = (code) => {
    const tempCode = code.replace(/[^a-zA-Z]/gi, '');
    const nextExecutiveCode = produce((draft) => {
      draft.value = tempCode;
    });
    stateMap.executiveCode.seter(nextExecutiveCode);
    if (tempCode.length === 4) {
      const executivePayload = {
        executiveCode: tempCode,
      };
      dispatch(executiveActions.fetchExecutive(Object.freeze(executivePayload)));
    }
  };
  /* istanbul ignore next */
  const handleContinueFlow = () => {
    sendAnalitycs(dataLayerObject.PERSONAL_DATA_CONTINUE);
    const personalDataToRegister = genPayloadToRegisterPersonalData(stateFields('object'));
    dispatch(personalDataActions.registerPersonalData(personalDataToRegister));
  };
  /* istanbul ignore next */
  const handleCancelFlow = () => {
    sendAnalitycs(dataLayerObject.PERSONAL_DATA_CANCEL);
    const token = sessionStorage.getItem('token');
    if (token) {
      setIsOpenModalAbandonmentSurvey(true);
      sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_LOAD, [
        {
          key: 'page',
          param: 'paso',
          value: window.location.pathname,
        },
      ]);
    } else window.location = appRoutes.landing.path;
  };
  /* istanbul ignore next */
  return (
    <PersonalDataTemplate
      rut={rut}
      serialNumber={serialNumber}
      previredAuthorization={previredAuthorization}
      firstName={firstName}
      lastName={lastName}
      maternalLastName={maternalLastName}
      position={position}
      profession={profession}
      workActivity={workActivity}
      countryNationality={countryNationality}
      regionsWithOfficesItems={regionsWithOfficesItems}
      officesItems={officesItems}
      preferredOffice={preferredOffice}
      phone={phone}
      confirmationPhone={confirmationPhone}
      email={email}
      address={address}
      taxDeclaration={taxDeclaration}
      isValidPerson={isValidPerson}
      isMobileDevice={isDeviceMobile}
      professionItems={professionItems}
      positionItems={positionItems}
      workActivityItems={workActivityItems}
      countryNationalityItems={countryNationalityItems}
      executiveCode={executiveCode}
      executive={executive.executive || {}}
      executiveAttending={executiveAttending}
      isCompletedCardPersonValidation={isCompletedCardPersonValidation}
      isCompletedCardPersonalData={isCompletedCardPersonalData}
      isCompletedCardContacData={isCompletedCardContacData}
      isCompletedCardPreferredOffice={isCompletedCardPreferredOffice}
      isCompletedCardDeclarationsData={isCompletedCardDeclarationsData}
      isOpenModalAlreadyMemberRedirection={isOpenModalAlreadyMemberRedirection}
      isOpenModalAbandonmentSurvey={isOpenModalAbandonmentSurvey}
      canContinueFlow={isValidStep}
      isOpenModalEdgeCase={isOpenModalEdgeCase}
      closeModalEdgeCase={closeModalEdgeCase}
      closeModalAbandonmentSurvey={closeModalAbandonmentSurvey}
      showIsRequiredPreviredAuthorization={showIsRequiredPreviredAuthorization}
      currentEdgeCase={currentEdgeCase}
      isValidExecutiveCode={isValidExecutiveCode}
      isVisiblePreferredOffice={isVisiblePreferredOffice}
      isLoadingValidatePersonalData={isLoadingValidatePersonalData}
      isLoadingFetchExecutive={isLoadingFetchExecutive}
      onChangePreferences={handleChangeField}
      onChangeExecutiveCode={handleChangeExecutiveCode}
      onChangeRegion={handleChangeRegion}
      onChangeOffice={handleChangeOffice}
      onChangeUserData={handleChangeField}
      onValidatePerson={handleValidatePerson}
      onActionButtonCaseBorder={handleActionButtonCaseBorder}
      // isSavedPersonalData={isSavedPersonalData}
      onContinueFlow={handleContinueFlow}
      onCancelFlow={handleCancelFlow}
    />
  );
};

export default PersonalDataContainer;
